<template>
  <div class="container">
    <van-nav-bar
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="title">
      <span>设置新密码</span>
    </div>
    <div class="form">
      <div class="group c_flex ">
        <div class="img c_flex_center c_flex fieldname">
          密码
        </div>
        <div class="content c_flex_1 c_item_center c_flex">
          <input type="password" v-model="new_password" placeholder="密码不能低于6位">
          <van-icon class="eye" name="closed-eye" @click="eyeClick($event)" />
        </div>
      </div>
      <div class="group c_flex c_item_center">
        <div class="border c_flex_1 c_flex">
          <div class="img c_flex_center c_flex fieldname">
            确认
          </div>
          <div class="content c_flex_1 c_item_center c_flex">
            <input class="c_flex_1" type="password" v-model="confirm_password" placeholder="请再次输入密码">
            <van-icon class="eye" name="closed-eye" @click="eyeClick($event)" />
          </div>
        </div>
        <!--<div class="time c_flex c_flex_center" :class="isSend?'bg_blue':'bg_gray'" @click="sendCode">{{tips}}</div>-->
      </div>
      <div class="group">
        <div class="opera bg_blue c_flex c_flex_center" @click="setPassword()">完成</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui';
  export default {
    name: "password-reset",
    data:function () {
      return {
        phone:'',
        new_password:'',
        confirm_password:''
      }
    },
    mounted:function(){
      if(!!localStorage['reset_phone']){
        this.phone = localStorage['reset_phone'];
      }
      this.$indicator.close();
    },
    methods:{
      //返回
      onClickLeft(){
        this.$router.push('/login');
      },
      //展示隐藏密码
      eyeClick(e){
       var el = e.currentTarget;
       if(el.className == 'eye van-icon van-icon-closed-eye'){
         el.className = 'eye van-icon van-icon-eye-o'; //展示
         el.previousElementSibling.attributes.type.value = 'text';
       }else{
         el.className = 'eye van-icon van-icon-closed-eye'; //隐藏
         el.previousElementSibling.attributes.type.value = 'password';
       }
      },
      //保存密码
      setPassword(){
        var $that = this;
        if($that.new_password.length < 6 || $that.confirm_password.length < 6){
          Toast({
            message: '密码长度至少6位',
            position: 'top',
            duration: 2000
          });
          return
        }
        if($that.new_password != $that.confirm_password){
          Toast({
            message: '两次输入密码不一致',
            position: 'top',
            duration: 2000
          });
          return
        }
        $that.$ajax.post($that.$$api.mobile.changePassword,{
          'phone':$that.phone,
          'new_password':$that.new_password,
          'confirm_password':$that.confirm_password,
        },function (res) {
          if(res.status == 200){
            if(res.data.status == '1'){
              $that.$toast(res.data.msg);
              localStorage.removeItem('userinfo_userpwd');
              $that.$router.push({path:'/main'});
            }else if(res.data.status == '-1'){
              $that.$toast(res.data.msg);
            }
          }else{
          }
          return
        },function (err) {
          console.log(err);
        });
      }
    }
  }
</script>

<style scoped>
  .container{
    background: #fff;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    margin-top:-9vh !important;
  }
  input{
    /*font-size: .5rem;*/
    font-size: 5vw;
  }
  .title{
    width: 100vw;
    height: calc(40vw - 46px);
    text-align: center;
    margin-top: 13vh;
    margin-bottom:2vh;
    font-size: 20px;
  }
  .group{
    width: 90%;
    margin: auto;
    /*height: 1rem;*/
    height: 10vw;
    overflow: hidden;
    margin-bottom: 8vw;
    padding-bottom:.5vh;
  }
  .group:first-child{
    border-bottom: .7px solid #ccc;
  }
  .content input{
    width: 100%;
    height: 100%;
    outline: 0;
    border: 0;
    padding: 0;
  }
  .border{
    border-bottom: .7px solid #ccc;
    width: 100%;
    overflow: hidden;
    padding-bottom:1vh;
  }
  .group:last-child{
    overflow: initial;
  }
  .opera{
    width: 100%;
    color:#fff;
    text-align: center;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    height: 13vw;
    line-height: 13vw;
    font-size: 5vw;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 6vh;
  }
  .van-hairline--bottom::after {
     border-bottom-width: 0px;
  }
  .fieldname{
    font-size: 18px;
    width: 15vw;
  }
  .eye{
    line-height: 10vw;
    padding:0 5px;
    text-align: center;
    color: rgb(3,162,228);
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/password-reset.vue